export const formatCountdown = ({
  days,
  hours,
  minutes,
  seconds,
  prefix,
}: {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  prefix: string;
}) => {
  let suffix: string;
  if (days > 0) {
    suffix = `${days}d`;
  } else if (hours > 0) {
    suffix = `${hours}h`;
  } else if (minutes > 0) {
    suffix = `${minutes}m`;
  } else {
    suffix = `${seconds}s`;
  }
  return `${prefix} ${suffix}`;
};

export const getPercentageMinted = ({
  limitedMinted,
  quantityUpperBound,
}: {
  limitedMinted: number;
  quantityUpperBound: number;
}) => `${Math.round(Math.min(limitedMinted / quantityUpperBound, 1) * 100)}% Minted`;
